<div class="modal-overlay" *ngIf="claim.visible" (click)="close()">
  <div class="modal-content" role="dialog" aria-modal="true" [attr.aria-label]="t('phoneClaim.title', 'Откройте полный расчёт')" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>{{ t('phoneClaim.title', 'Откройте полный расчёт') }}</h2>
      <button class="modal-close" type="button" (click)="close()" [disabled]="saving" aria-label="Close">
        <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
      </button>
    </div>
    <div class="modal-body">
      <p class="modal-hint">{{ t('phoneClaim.hint', 'Укажите имя и телефон — расчёт сохранится за вами, и откроется:') }}</p>
      <!-- Что даёт ввод данных — до полей, чтобы было понятно, ради чего их заполнять -->
      <ul class="claim-benefits">
        <li *ngFor="let b of benefits">
          <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M5 10.5l3.5 3.5L15 7"/></svg>
          <span>{{ t(b.key, b.fallback) }}</span>
        </li>
      </ul>

      <div class="form-group">
        <label for="phone-claim-name">{{ t('phoneClaim.nameLabel', 'Имя') }}</label>
        <input
          id="phone-claim-name"
          type="text"
          autocomplete="name"
          class="form-control form-control--text"
          [(ngModel)]="nameInput"
          [placeholder]="t('phoneClaim.namePlaceholder', 'Как к вам обращаться')"
          (keydown.enter)="focusPhone()"
          maxlength="80"
          [disabled]="saving"
        />
      </div>
      <div class="form-group">
        <label for="phone-claim-input">{{ t('phoneClaim.label', 'Телефон') }}</label>
        <input
          id="phone-claim-input"
          #phoneField
          type="tel"
          inputmode="tel"
          autocomplete="tel"
          class="form-control"
          [ngModel]="phoneInput"
          (ngModelChange)="onPhoneInput($event)"
          (keydown)="onPhoneKeydown($event)"
          (keydown.enter)="confirm()"
          (paste)="onPhonePaste($event)"
          maxlength="16"
          [disabled]="saving"
        />
      </div>
      <div *ngIf="error" class="error-message" role="alert">{{ error }}</div>
      <div class="modal-actions">
        <button type="button" class="btn btn-secondary" (click)="close()" [disabled]="saving">{{ t('phoneClaim.cancel', 'Отмена') }}</button>
        <button type="button" class="btn btn-primary" (click)="confirm()" [disabled]="saving">{{ t('phoneClaim.continue', 'Продолжить') }}</button>
      </div>
    </div>
  </div>
</div>
